export function company(state = {}, action) {
  switch (action.type) {
    case 'INITIALIZATION_DATA':
      return action.data.currentPerson.company || {};
    default:
      return state;
  }
}
